export default __webpack_public_path__ + "static/media/send_dark.e9272364.svg";